import { Component, Input } from '@angular/core'

@Component({
  selector: 'se-po-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
  standalone: false,
})
export class ProgressCircleComponent {
  public readonly size = 32
  public readonly apothem = this.size / 2
  public readonly radius = this.apothem - 2
  public readonly circumference = 2 * this.radius * Math.PI
  public dashoffset: number

  private _percentage: number

  constructor() {
    // noop
  }

  public get percentage(): number {
    return this._percentage
  }

  @Input() public set percentage(percentage: number) {
    this._percentage = percentage
    this.dashoffset = this.percentageDashoffset(percentage)
  }

  public percentageDashoffset(percentage: number): number {
    return this.circumference - percentage / 100 * this.circumference
  }
}
